import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Dialog, DialogContent, DialogTitle } from '../../../../../components/Common/UI/Dialog';
import Icons from '../../../../../components/Common/Icons/Icons';
import { Button } from '../../../../../components/Common/UI/Button';
import DataTable from '../../../../../components/Common/UI/DataTable';
import {
  undeliverableEmailAUser,
  undeliverableEmailData,
  unreviewedDocsCol,
  unreviewedDocsData,
  UnreviewedDocsData,
  unreviewedDocsDataAUser,
} from './data';
import { Input } from '../../../../../components/Common/UI/Input';
import { IAccountData } from '../../../Layout/Account/Data';

const viewerUpdatesRaw = localStorage.getItem('viewerUpdates');

const ALLOWED_ACCOUNTS_FOR_NON_ADMIN = viewerUpdatesRaw
  ? (JSON.parse(viewerUpdatesRaw).find((u: IAccountData) => u.id === '1')?.selectedAccounts ?? [])
  : ['4560', '4564'];

function UnreviewedDocDialog() {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [stateTable, setStateTable] = useState<UnreviewedDocsData[]>([]);
  const [searchVal, setSearchVal] = useState('');
  const [step, setStep] = useState(0);
  const [isAuthorizedUser, setIsAuthorizedUser] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();

  const getSourceData = () => {
    let data: UnreviewedDocsData[];

    if (step === 0) {
      data = isAuthorizedUser ? unreviewedDocsDataAUser : unreviewedDocsData;
    } else {
      data = isAuthorizedUser ? undeliverableEmailAUser : undeliverableEmailData;
    }

    if (!isAuthorizedUser) return data;

    return data.filter(item =>
      ALLOWED_ACCOUNTS_FOR_NON_ADMIN.some((acc: string) => item.account.endsWith(acc.replace(/\*/g, '')))
    );
  };

  useEffect(() => {
    const tempViewers = JSON.parse(localStorage.getItem('tempViewers') || '[]');
    // const viewerUpdates = JSON.parse(localStorage.getItem('viewerUpdates') || '[]');

    const authorized = tempViewers.length > 0;

    setIsAuthorizedUser(authorized);
  }, []);

  useEffect(() => {
    const newDocs = searchParams.get('unreviewed-document');

    if (newDocs === 'yes') {
      setModalOpen(true);
      setSearchParams({});
    }
  }, []);

  useEffect(() => {
    setStateTable(getSourceData());
    setSearchVal('');
  }, [step, isAuthorizedUser]);

  const handleNextStep = () => {
    setStep(prevState => prevState + 1);
  };

  /** Search: */
  const handleSearch = (val: string) => {
    setSearchVal(val);
  };

  useEffect(() => {
    const sourceData = getSourceData();

    const filterCallback = () => {
      const filtered = sourceData.filter(item =>
        Object.values(item).some(value => value.toString().toLowerCase().includes(searchVal.toLowerCase()))
      );

      setStateTable(filtered);
    };

    const timeoutId = setTimeout(filterCallback, 400);

    return () => clearTimeout(timeoutId);
  }, [searchVal, step, isAuthorizedUser]);

  return (
    <Dialog open={modalOpen} onOpenChange={isOpen => setModalOpen(isOpen)}>
      <DialogContent className="guidance max-h-[98%] max-w-5xl">
        <DialogTitle className="flex items-center gap-4 mb-[10px]">
          <Icons.AccountsFilled className="size-[34px]" />
          <p className="text-xl leading-none">{step === 0 ? 'Unreviewed Document' : 'Undeliverable Email Address'}</p>
        </DialogTitle>

        {step === 1 ? (
          <div>
            <p>
              These are the following email address you have undeliverable email which may be due to a bad email
              address.
            </p>
            <p>
              <b>carson@guidance.com</b> Click on the statement options tab to update your email address
            </p>
            <p className="text-lg text-center mt-2 leading-none">Unreviewed Document</p>
          </div>
        ) : null}

        <div className="flex justify-between items-center gap-4 child:flex-grow">
          <p>You have following new unreviewed documents.</p>

          <Input
            prefix="Search"
            variant="guidance"
            className="max-w-60"
            value={searchVal}
            icon={<Icons.Search />}
            onChange={e => handleSearch(e.target.value)}
          />
        </div>
        <DataTable
          variant="guidance2"
          columns={unreviewedDocsCol}
          data={stateTable}
          initialState={{ pagination: { pageSize: 5 } }}
          paginationPosition="bottom"
          paginationVariant="guidance"
        />

        <div className="flex justify-end gap-4">
          <Button variant="link" className="py-3 hover:no-underline" onClick={() => setModalOpen(false)}>
            Dismiss
          </Button>
          <Button
            variant="dark"
            className="py-3"
            onClick={() => {
              if (step === 0) {
                handleNextStep();

                return;
              }
              navigate('/guidance/profile');
              setModalOpen(false);
            }}
          >
            {step === 0 ? 'Next' : 'Profile'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default UnreviewedDocDialog;
